import AppContext from "../../AppContext";
import "./SelectedPackageBanner.css";
import { useContext, useState } from "react";
import PropTypes from 'prop-types';

const SelectedPackageBanner = ({ product }) => {
  const { selectedProduct } = useContext(AppContext);

  const [packages] = useState({
    1: {
      colorClass: "banner__recharge__color__rechage",
      slectedClass: "",
      prefix: "R",
    },
    2: {
      colorClass: "banner__recharge__color__telcel__network",
      slectedClass: "",
      prefix: "INT",
    },
    3: {
      colorClass: "banner__recharge__color__rechage",
      slectedClass: "",
      prefix: "ILIM",
    },
    4: {
      colorClass: "banner__recharge__color__unlimited",
      slectedClass: "selected__banner__recharge__color__unlimited",
      prefix: "SL",
    },
    6: {
      colorClass: "banner__recharge__color__entertainment",
      slectedClass: "",
      prefix: "RE",
    },
  });
  let {
    category: { categoryId },
    amount,
    productId,
  } = product;

  return (
    <span
      className={`banner__indicator__recharge ${
        packages[categoryId] ? packages[categoryId].colorClass : ""
      }
      ${
        selectedProduct?.productId === productId && packages[categoryId]
          ? packages[categoryId].slectedClass
          : ""
      }`}
    >
      {`${packages[categoryId] ? packages[categoryId].prefix : ""}${amount}`}
    </span>
  );
};

SelectedPackageBanner.propTypes = {
  product: PropTypes.object,
};

export default SelectedPackageBanner;
